import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "../../Component/Table/Table";
import { URLS } from "../../Services/Constant";
import { get, post as postApi } from "../../Services/ApiHandler";
import Footer from "../../Component/Footer/Footer";
import { Toast } from "../../Component/Toast";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";
import { delete_icon } from "../../assets/img";
import Select from "react-select";
import { PRIMARY_COLOR, PRIMARY_COLOR_RGB } from "../../Services/Colors";
/* ── shared input style ── */
const popupInput = {
  width: "100%",
  height: 44,
  borderRadius: 8,
  border: `1.5px solid ${PRIMARY_COLOR}`,
  padding: "0 12px",
  fontSize: 14,
  background: "#F0EDE6",
  color: "#1B1B1B",
  outline: "none",
  boxSizing: "border-box",
  fontFamily: "inherit",
};

const popupLabel = {
  fontSize: 13,
  fontWeight: 600,
  color: PRIMARY_COLOR,
  marginBottom: 5,
  display: "block",
};

const DIGIT_OPTIONS = [
  { value: 1, label: "Single (1 digit)" },
  { value: 2, label: "Double (2 digits)" },
  { value: 3, label: "Three (3 digits)" },
  { value: 4, label: "Four (4 digits)" },
];

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    background: "#F0EDE6",
    border: `1.5px solid ${PRIMARY_COLOR}`,
    borderRadius: 8,
    minHeight: 44,
    boxShadow: "none",
    "&:hover": { border: `1.5px solid ${PRIMARY_COLOR}` },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? PRIMARY_COLOR : state.isFocused ? "#f5e6ec" : "#F0EDE6",
    color: state.isSelected ? "#fff" : PRIMARY_COLOR,
    cursor: "pointer",
  }),
  singleValue: (provided) => ({ ...provided, color: "#1B1B1B" }),
  placeholder: (provided) => ({ ...provided, color: "#aaa" }),
  menu: (provided) => ({ ...provided, background: "#F0EDE6", borderRadius: 8, zIndex: 9999 }),
  indicatorSeparator: () => ({ display: "none" }),
};
/* ─────────────────────────────────────────
   ADD LOT POPUP
───────────────────────────────────────── */
const AddLotPopup = ({ open, onClose, groupType, onSuccess }) => {
  const emptyForm = { digit: "", lot_name: "", client_price: "", max_quantity: "" };
  const [form, setForm]     = useState(emptyForm);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) { setForm(emptyForm); setErrors({}); } }, [open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const e = {};
    if (!form.digit)           e.digit        = "Select a digit type";
    if (!form.lot_name.trim()) e.lot_name     = "Lot group name is required";
    if (!form.client_price)    e.client_price = "Client price is required";
    else if (isNaN(Number(form.client_price)) || Number(form.client_price) < 0)
                               e.client_price = "Enter a valid price";
    if (!form.max_quantity)    e.max_quantity = "Maximum quantity is required";
    else if (isNaN(Number(form.max_quantity)) || Number(form.max_quantity) < 1)
                               e.max_quantity = "Enter a valid quantity";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSave = async () => {
    if (!validate()) return;
    try {
      setSaving(true);
      const payload = {
        type:             Number(form.digit),
        name:             form.lot_name.trim(),
        client_price:     Number(form.client_price),
        maximum_quantity: Number(form.max_quantity),
        group_type:       groupType === "dear" ? "Dear" : "Kerala",
      };
      const res = await postApi(`lotprice/create`, payload);
      if (res?.status === "success") {
        Toast("Lot added successfully!");
        onSuccess();
        onClose();
      } else {
        Toast(res?.message || "Failed to add lot");
      }
    } catch (err) {
      Toast("Failed to add lot");
    } finally {
      setSaving(false);
    }
  };

  if (!open) return null;

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 10000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
      onClick={onClose}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{ background: "#F0EDE6", borderRadius: 14, width: "100%", maxWidth: 440, maxHeight: "90vh", display: "flex", flexDirection: "column", boxShadow: `0 8px 32px rgba(${PRIMARY_COLOR_RGB.join(",")},0.18)`, overflow: "hidden" }}
      >
        <div style={{ background: PRIMARY_COLOR, padding: "14px 18px", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
          <span style={{ color: "#fff", fontWeight: 700, fontSize: 16 }}>
            Add {groupType === "dear" ? "Dear" : "Kerala"} Lot
          </span>
          <button onClick={onClose} style={{ background: "transparent", border: "none", color: "#fff", fontSize: 22, cursor: "pointer", lineHeight: 1, padding: "0 2px" }}>×</button>
        </div>

        <div style={{ overflowY: "auto", flex: 1, padding: "18px 18px 8px", display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <label style={popupLabel}>Digit Type</label>
            <Select
              noOptionsMessage={() => ""}
              options={DIGIT_OPTIONS.map(o => ({ value: o.value, label: o.label }))}
              value={form.digit ? DIGIT_OPTIONS.map(o => ({ value: o.value, label: o.label })).find(o => o.value === Number(form.digit)) : null}
              onChange={(selected) => {
                setForm(prev => ({ ...prev, digit: selected ? selected.value : "" }));
                setErrors(prev => ({ ...prev, digit: "" }));
              }}
              placeholder="Select digit type"
              isSearchable={false}
              styles={customStyles}
            />
            {errors.digit && <p style={{ color: "red", fontSize: 11, margin: "3px 0 0" }}>{errors.digit}</p>}
          </div>

          <div>
            <label style={popupLabel}>Lot Group Name</label>
            <input style={popupInput} name="lot_name" value={form.lot_name} onChange={handleChange} placeholder="Enter lot group name" type="text" />
            {errors.lot_name && <p style={{ color: "red", fontSize: 11, margin: "3px 0 0" }}>{errors.lot_name}</p>}
          </div>

          <div>
            <label style={popupLabel}>Client Price</label>
            <input
              style={popupInput} name="client_price" value={form.client_price}
              onChange={(e) => { const v = e.target.value.replace(/[^\d.]/g, ""); setForm(prev => ({ ...prev, client_price: v })); setErrors(prev => ({ ...prev, client_price: "" })); }}
              placeholder="Enter client price" type="text" inputMode="decimal"
            />
            {errors.client_price && <p style={{ color: "red", fontSize: 11, margin: "3px 0 0" }}>{errors.client_price}</p>}
          </div>

          <div>
            <label style={popupLabel}>Maximum Quantity</label>
            <input
              style={popupInput} name="max_quantity" value={form.max_quantity}
              onChange={(e) => { const v = e.target.value.replace(/\D/g, ""); setForm(prev => ({ ...prev, max_quantity: v })); setErrors(prev => ({ ...prev, max_quantity: "" })); }}
              placeholder="Enter maximum quantity" type="text" inputMode="numeric"
            />
            {errors.max_quantity && <p style={{ color: "red", fontSize: 11, margin: "3px 0 0" }}>{errors.max_quantity}</p>}
          </div>
        </div>

        <div style={{ padding: "12px 18px 18px", display: "flex", gap: 10, flexShrink: 0 }}>
          <button onClick={onClose} style={{ flex: 1, height: 44, borderRadius: 8, border: `1.5px solid ${PRIMARY_COLOR}`, background: "transparent", color: PRIMARY_COLOR, fontWeight: 600, cursor: "pointer", fontSize: 14 }}>Cancel</button>
          <button onClick={handleSave} disabled={saving} style={{ flex: 1, height: 44, borderRadius: 8, border: "none", background: saving ? "#7ea1b8cc" : PRIMARY_COLOR, color: "#fff", fontWeight: 700, cursor: saving ? "not-allowed" : "pointer", fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
            {saving ? <><span className="spinner-border spinner-border-sm" style={{ color: "#fff", width: 14, height: 14 }} />Saving…</> : "Add Lot"}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────── */
const LotPrice = () => {
  const navigate = useNavigate();
  const { kv, set } = useStoreKv();
  const lotDear   = kv.lotdear   || [];
  const lotKerala = kv.lotkerala || [];

  const [owners,   setOwners]   = useState(lotDear);
  const [kerala,   setKerala]   = useState(lotKerala);
  const [pagination, setPagination] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [popup,    setPopup]    = useState(false);
  const [loadingId,     setLoadingId]     = useState(null);
  const [loadingType,   setLoadingType]   = useState(null);
  const [loadingAction, setLoadingAction] = useState(null);
  const [updateItem,    setUpdateItem]    = useState(null);
  const [updateType,    setUpdateType]    = useState(null);
  const [updateAction,  setUpdateAction]  = useState(null);

  const [addPopupOpen,  setAddPopupOpen]  = useState(false);
  const [addPopupGroup, setAddPopupGroup] = useState("dear");

  const getList = async () => {
    try {
      if (!kv.lotdear || kv.lotdear.length === 0) setLoading(true);
      const res = await get(`${URLS.LOTPRICELIST}`);
      if (res?.status === "success" && Array.isArray(res?.data)) {
        setOwners(res?.data[0]?.lots || []);
        setKerala(res?.data[1]?.lots || []);
        set("lotdear",   res?.data[0]?.lots || []);
        set("lotkerala", res?.data[1]?.lots || []);
      } else {
        Toast("Invalid data format received");
        setOwners([]); setKerala([]);
        set("lotdear", []); set("lotkerala", []);
      }
    } catch (err) {
      Toast("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { getList(); }, []);

  const handleUpdate = async (row, type, actionType) => {
    setLoading1(true);
    setLoadingId(row?.id);
    setLoadingType(type);
    setLoadingAction(actionType);

    const updatedStatus = actionType === "delete" ? (row.status === 1 ? 0 : 1) : row.status;

    const payload = {
      name:             row?.lot_name,
      client_price:     row?.client_price,
      maximum_quantity: Number(row?.maximum_quantity),
      status:           updatedStatus,
      group_type:       type === "dear" ? "Dear" : "Kerala",
      fee_price_id:     row?.fee_price_id,
    };

    try {
      const res = await postApi(`${URLS.LOTPRICEUPDATE}`, payload);
      if (res?.status === "success") {
        Toast("Updated successfully!");
        await getList();
      } else {
        Toast(res?.message || "Update failed");
      }
    } catch (err) {
      Toast("Failed to update price");
    } finally {
      setLoading1(false); setLoadingId(null); setLoadingType(null); setLoadingAction(null);
    }
  };

  const handleDelete = async (row, type) => {
    setLoading1(true);
    setLoadingId(row?.id);
    setLoadingType(type);
    setLoadingAction("remove");
    try {
      const res = await postApi(`/lotprice/delete`, {fee_price_id: row?.fee_price_id});
      if (res?.status === "success") {
        Toast("Deleted successfully!");
        await getList();
      } else {
        Toast(res?.message || "Delete failed");
      }
    } catch (err) {
      Toast("Failed to delete");
    } finally {
      setLoading1(false); setLoadingId(null); setLoadingType(null); setLoadingAction(null);
    }
  };

  const getColumns = (list, setList, type) => [
    {
      Header: "Lot Group",
      accessor: "lot_name",
      Cell: ({ row }) => {
        const handleChange = (e) => {
          const updated = [...list];
          updated[row.index] = { ...updated[row.index], lot_name: e.target.value };
          setList(updated);
        };
        return (
          <div style={{ width: 150 }}>
            <input
              type="text"
              defaultValue={row.original.lot_name}
              onBlur={handleChange}
              className="form-control6 text-center placholdercolorchanges2"
              placeholder="Enter group name"
            />
          </div>
        );
      },
    },
    {
      Header: "Client Price",
      accessor: "client_price",
      Cell: ({ row }) => {
        const handleChange = (e) => {
          const updated = [...list];
          updated[row.index] = { ...updated[row.index], client_price: e.target.value };
          setList(updated);
        };
        return (
          <div>
            <input
              type="number"
              min="0"
              defaultValue={row.original.client_price}
              onBlur={handleChange}
              className="form-control6 text-center placholdercolorchanges2"
              placeholder="Enter price"
            />
          </div>
        );
      },
    },
    {
      Header: "Max Quantity",
      accessor: "maximum_quantity",
      Cell: ({ row }) => {
        const handleChange = (e) => {
          const updated = [...list];
          updated[row.index] = { ...updated[row.index], maximum_quantity: e.target.value };
          setList(updated);
        };
        return (
          <div>
            <input
              type="number"
              min="1"
              defaultValue={row.original.maximum_quantity}
              onBlur={handleChange}
              className="form-control6 text-center placholdercolorchanges2"
              placeholder="Enter max qty"
            />
          </div>
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) => (
        <div className="d-flex ac-jc">
          <button
            onClick={() => { setUpdateItem(row.original); setUpdateType(type); setUpdateAction("delete"); setPopup(true); }}
            className={`${list[row.index]?.status === 0 ? "deactive-icon1" : "active-icon1"} f2 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-12 fs-xl-12 fs-xxl-13`}
          >
            {loadingId === row.original?.id && loadingType === type && loadingAction === "delete"
              ? <span className="spinner-border spinner-border-sm" style={{ color: "white", width: 10, height: 10 }} />
              : list[row.index]?.status === 0 ? "Deactive" : "Active"}
          </button>
        </div>
      ),
    },
    {
      Header: "Action",
      accessor: "action",
      Cell: ({ row }) => (
        <div className="d-flex ac-jc">
          <button
            className="update-btn f2 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-12 fs-xl-12 sec fs-xxl-13"
            onClick={() => { setUpdateItem(row.original); setUpdateType(type); setUpdateAction("update"); setPopup(true); }}
          >
            {loadingId === row.original?.id && loadingType === type && loadingAction === "update"
              ? <span className="spinner-border spinner-border-sm" style={{ color: "white", width: 10, height: 10 }} />
              : "Update"}
          </button>
        </div>
      ),
    },
    {
      Header: "Delete",
      accessor: "delete",
      Cell: ({ row }) => (
        <div className="d-flex ac-jc">
          <button
            onClick={() => { setUpdateItem(row.original); setUpdateType(type); setUpdateAction("remove"); setPopup(true); }}
            className="cust-btn"
          >
            {loadingId === row.original?.id && loadingType === type && loadingAction === "remove"
              ? <span className="spinner-border spinner-border-sm" style={{ color: PRIMARY_COLOR, width: 14, height: 14 }} />
              : <img src={delete_icon} alt="" className="delete-icon" />}
          </button>
        </div>
      ),
    },
  ];

  const dearColumns   = useMemo(() => getColumns(owners, setOwners, "dear"),   [owners,  loadingId, loadingType, loadingAction]);
  const keralaColumns = useMemo(() => getColumns(kerala, setKerala, "kerala"), [kerala, loadingId, loadingType, loadingAction]);

  const addBtnStyle = {
    display: "inline-flex", alignItems: "center", gap: 6,
    background: PRIMARY_COLOR, color: "#fff", border: "none",
    borderRadius: 8, padding: "7px 15px", fontWeight: 700,
    fontSize: 13, cursor: "pointer",
    boxShadow: `0 2px 8px rgba(${PRIMARY_COLOR_RGB.join(",")},0.22)`,
  };

  return (
    <div className="dashRightView d-flex ac-jb flex-column">
      <CustomScroll height="100vh">
        <div style={{ paddingTop: 0 }} className="container_overalls">

          <div className="col-md-5 my-2" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <label className="f3 fs-xs-17 fs-sm-14 fs-md-17 fs-lg-19 fs-xl-20 fs-xxl-22 primary mb-0">Dear Price List</label>
            <button style={addBtnStyle} onClick={() => { setAddPopupGroup("dear"); setAddPopupOpen(true); }}>
              Add
            </button>
          </div>

          <Table columns={dearColumns} data={owners} pagecount={pagination} show={false} tableMargin="25px" loading={loading} />

          <div className="col-md-5 my-2" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <label className="f3 fs-xs-17 fs-sm-14 fs-md-17 fs-lg-19 fs-xl-20 fs-xxl-22 primary mb-0">Kerala Price List</label>
            <button style={addBtnStyle} onClick={() => { setAddPopupGroup("kerala"); setAddPopupOpen(true); }}>
              Add
            </button>
          </div>

          <Table columns={keralaColumns} data={kerala} pagecount={pagination} show={false} loading={loading} />
        </div>

        <Footer />

        {popup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                {updateAction === "remove"
                  ? "Are you sure you want to Delete this lot?"
                  : "Are you sure you want to Update?"}
              </p>
              <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                <button onClick={() => { setPopup(false); setUpdateItem(null); setUpdateType(null); setUpdateAction(null); }} className="no-btn w-40">No</button>
                <button
                  onClick={async () => {
                    if (updateAction === "remove") {
                      await handleDelete(updateItem, updateType);
                    } else {
                      await handleUpdate(updateItem, updateType, updateAction);
                    }
                    setPopup(false);
                    setUpdateItem(null); setUpdateType(null); setUpdateAction(null);
                  }}
                  className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                >
                  {loading1
                    ? <span className="spinner-border spinner-border-sm" role="status" style={{ color: "white", padding: 8 }} />
                    : <span style={{ top: -1.5, position: "relative" }}>Yes</span>}
                </button>
              </div>
            </div>
          </div>
        )}
      </CustomScroll>

      <AddLotPopup open={addPopupOpen} onClose={() => setAddPopupOpen(false)} groupType={addPopupGroup} onSuccess={getList} />
    </div>
  );
};

export default LotPrice;